import Seller from '../../../../components/seller-info-label/seller-info.desktop';
import seller from './seller';

export default seller(Seller);
